import React, { useState } from 'react';
import { CheckCircle, Award, Recycle, Factory, Truck } from 'lucide-react';
import './HomeSecond.css';
import Title from '../../components/Title/Title';

const HomeSecond: React.FC = () => {
  const [activeFeature, setActiveFeature] = useState<number | null>(null);

  return (
    <section className="home-second-container">
      <div className="home-second-content">
        <Title
          animated="Umweltschutz durch Styropor Recycling,"
          static="... der Ihren Gewinn steigert!"
        />
        
        <div className="home-second-benefits">
          <div className="home-second-benefit">
            <div className="home-second-benefit-icon">
              <CheckCircle size={32} />
            </div>
            <p>Ihr Unternehmen spart teure Entsorgungskosten in Hamburg!</p>
          </div>
          <div className="home-second-benefit">
            <div className="home-second-benefit-icon">
              <CheckCircle size={32} />
            </div>
            <p>Gleichzeitig schützen Sie Natur und Umwelt durch verantwortungsvolles EPS Recycling!</p>
          </div>
        </div>

        <div className="home-second-certificate">
          <div className="home-second-certificate-icon">
            <Award size={64} />
          </div>
          <div className="home-second-certificate-content">
            <h3>Umweltschutz-Zertifikat</h3>
            <p>Zeigen Sie Ihren Kunden und der Welt, dass Sie und Ihr Unternehmen aktiv Umweltschutz betreiben durch professionelles Styropor Recycling! Mit unserem Umweltschutz-Zertifikat dokumentieren Sie Ihr Engagement für nachhaltiges Recycling und verantwortungsvolle Entsorgung. Das stärkt Ihr Unternehmensimage und schafft Vertrauen bei umweltbewussten Kunden und Geschäftspartnern. StyroR stellt das Zertifikat nach erfolgreicher Zusammenarbeit aus – ein sichtbares Zeichen für gelebte Nachhaltigkeit.</p>
          </div>
        </div>

        <div className="home-second-features">
          <Title
            static="Unsere Merkmale"
          />
          <div className="home-second-features-grid">
            {[
              { icon: <Recycle size={48} />, title: "Zirkuläres Schaumstoff-Kreislauf-Management", description: "Geschlossener Styropor-Kreislauf für maximale Effizienz. StyroR führt recyceltes EPS und Polystyrol zurück in den Produktionskreislauf. So entsteht aus altem Styropor wieder neues Material – echtes Recycling in Hamburg." },
              { icon: <Factory size={48} />, title: "Universelles EPS Recycling & Styropor Entsorgung", description: "Wir recyceln und entsorgen alle Arten von Styropor: sauber, verdreckt, verunreinigt und auch HBCD-belastet. Kein Styropor ist zu schwierig für unser Recycling-Team. Kontaktieren Sie StyroR für eine individuelle Lösung." },
              { icon: <Truck size={48} />, title: "Zertifizierte Partner-Fachbetriebe in Hamburg", description: "Unser Netzwerk zertifizierter Partner-Fachbetriebe deckt die gesamte Recycling-Kette ab: Transport, Aufbereitung, Maschinenbau und Produktion im Raum Hamburg. StyroR koordiniert das Styropor Recycling von Anfang bis Ende." }
            ].map((feature, index) => (
              <div 
                key={index}
                className={`home-second-feature ${activeFeature === index ? 'active' : ''}`}
                onMouseEnter={() => setActiveFeature(index)}
                onMouseLeave={() => setActiveFeature(null)}
              >
                <div className="home-second-feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSecond;